module.exports = __webpack_public_path__ + "static/media/06.71bf449c.mp3";